export default "__VITE_ASSET__DKJ7TKzs__"